import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

const guest_only_routes = ["/auth", "/auth/sign-up", "/auth/sign-in"];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      name: "not-found",
      component: () => import("@/views/NotFound.vue"),
      meta: {
        auth_required: false,
      },
    },
    {
      path: "/",
      redirect: "/auth/sign-in",
      meta: {
        auth_required: false,
      },
    },
    {
      path: "/auth/sign-up",
      name: "sign-up",
      component: () => import("@/views/SignUp.vue"),
      meta: {
        auth_required: false,
      },
    },
    {
      path: "/auth/sign-in",
      name: "sign-in",
      component: () => import("@/views/SignIn.vue"),
      meta: {
        auth_required: false,
      },
    },
    {
      path: "/auth/sign-out",
      name: "sign-out",
      meta: {
        auth_required: true,
      },
    },
    {
      path: "/profile-creation",
      name: "profile-creation",
      component: () => import("@/views/profile-creation/ProfileCreation.vue"),
      redirect: "/profile-creation/personal-information",
      meta: {
        auth_required: true,
      },
      children: [
        {
          path: "personal-information",
          name: "profile-creation-personal-information",
          component: () =>
            import("@/views/profile-creation/PersonalInformation.vue"),
        },
        {
          path: "short-bio",
          name: "profile-creation-short-bio",
          component: () => import("@/views/profile-creation/ShortBio.vue"),
        },
        {
          path: "work-history",
          name: "profile-creation-work-history",
          component: () => import("@/views/profile-creation/WorkHistory.vue"),
        },
        {
          path: "project-reference",
          name: "profile-creation-project-reference",
          component: () =>
            import("@/views/profile-creation/ProjectReference.vue"),
        },
        {
          path: "industry-and-functional-expertise",
          name: "profile-creation-industry-and-functional-expertise",
          component: () =>
            import(
              "@/views/profile-creation/IndustryAndFunctionalExpertise.vue"
            ),
        },
        {
          path: "time-availability",
          name: "profile-creation-time-availability",
          component: () =>
            import("@/views/profile-creation/TimeAvailability.vue"),
        },
        {
          path: "awards-and-certification",
          name: "profile-creation-awards-and-certification",
          component: () =>
            import("@/views/profile-creation/AwardsAndCertification.vue"),
        },
        {
          path: "interest-and-contribution",
          name: "profile-creation-interest-and-contribution",
          component: () =>
            import("@/views/profile-creation/InterestAndContribution.vue"),
        },
      ],
    },
    {
      path: "/profile-creation-summary",
      name: "profile-creation-summary",
      component: () => import("@/views/ProfileCreationSummary.vue"),
      meta: {
        auth_required: true,
      },
    },
    {
      path: "/expert-profile/:expertProfileId",
      name: "expert-profile",
      props: ({ params }) => ({
        expertProfileId: parseInt(params.expertProfileId) || 0,
      }),
      component: () => import("@/views/expert-profile/ExpertProfile.vue"),
      redirect: (to) => {
        console.log({ to });
        return `/expert-profile/${
          to.params.expertProfileId || "0"
        }/personal-information`;
      },
      meta: {
        auth_required: true,
      },
      children: [
        {
          path: "personal-information",
          name: "expert-profile-personal-information",
          props: ({ params }) => ({
            expertProfileId: parseInt(params.expertProfileId) || 0,
          }),
          component: () =>
            import("@/views/expert-profile/PersonalInformation.vue"),
        },
        {
          path: "industry-and-functional-expertise",
          name: "expert-profile-industry-and-functional-expertise",
          props: ({ params }) => ({
            expertProfileId: parseInt(params.expertProfileId) || 0,
          }),
          component: () =>
            import("@/views/expert-profile/IndustryAndFunctionalExpertise.vue"),
        },
        {
          path: "project-reference",
          name: "expert-profile-project-reference",
          props: ({ params }) => ({
            expertProfileId: parseInt(params.expertProfileId) || 0,
          }),
          component: () =>
            import("@/views/expert-profile/ProjectReference.vue"),
        },
        {
          path: "awards-and-certification",
          name: "expert-profile-awards-and-certification",
          props: ({ params }) => ({
            expertProfileId: parseInt(params.expertProfileId) || 0,
          }),
          component: () =>
            import("@/views/expert-profile/AwardsAndCertification.vue"),
        },
        {
          path: "*",
          redirect: "/profile-creation-summary",
        },
      ],
    },
    {
      path: "/expert-profile-summary/:expertProfileId?",
      name: "expert-profile-summary",
      props: ({ params }) => ({
        expertProfileId: parseInt(params.expertProfileId) || undefined,
      }),
      component: () => import("@/views/ExpertProfileSummary.vue"),
      meta: {
        auth_required: true,
      },
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("@/views/dashboard/Home.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/applied-jobs",
      name: "AppliedJobs",
      component: () => import("@/views/dashboard/AppliedJobs.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/job-history",
      name: "JobHistory",
      component: () => import("@/views/dashboard/JobHistory.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/ongoing-jobs",
      name: "OngoingJobs",
      component: () => import("@/views/dashboard/OngoingJobs.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/my-interested-jobs",
      name: "MyInterestedJobs",
      component: () => import("@/views/dashboard/MyInterestedJobs.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/job-filter",
      name: "JobFilter",
      props: route => ({ query: route.query.search_term }),
      component: () => import("@/views/dashboard/JobFilter.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/job-details/:id",
      name: "JobDetails",
      props: true,
      component: () => import("@/views/dashboard/JobDetails.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/apply",
      name: "Apply",
      props: route => ({ job: route.query.job, expert_profile: route.query.expert_profile }),
      component: () => import("@/views/dashboard/Apply.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/job-applied/:id",
      name: "JobApplied",
      props: true,
      component: () => import("@/views/dashboard/JobApplied.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    {
      path: "/job-invitation",
      name: "JobInvitation",
      component: () => import("@/views/dashboard/JobInvitation.vue"),
      meta: { 
        auth_required: true, 
      }, 
    },
    { 
      path: "/accept-invitation/:id", 
      name: "AcceptInvite", 
      props: true,
      component: () => import("@/views/dashboard/AcceptInvite.vue"), 
      meta: { 
        auth_required: true, 
      }, 
    }, 
  ],
});

router.beforeEach((to, from, next) => {
  const current_user = store.getters.auth_user;
  const auth_is_required = to.matched.some((x) => x.meta.auth_required);

  if (auth_is_required && !current_user) {
    next({
      path: "/auth/sign-in",
      query: {
        redirect: to.path,
      },
    });
  } else if (current_user && guest_only_routes.includes(to.path)) {
    next("/dashboard");
  } else if (auth_is_required && current_user) {
    if (to.path === "/auth/sign-out") {
      store.dispatch("setAuthUser", undefined);
      next("/");
    }
    next();
  } else {
    next();
  }
});

export default router;
